import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as reset from '../state';
import { resetPassword } from '../state';

@Component({
  selector: 'tc-reset-page',
  templateUrl: './reset-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPageComponent {
  public pending$ = this.store$.pipe(select(reset.select.pending));
  public error$ = this.store$.pipe(select(reset.select.error));
  public value$ = this.route.params;

  constructor(private store$: Store<reset.State>, private route: ActivatedRoute) {}

  public onSubmit($event: reset.ResetPassword): void {
    this.store$.dispatch(resetPassword({ payload: $event }));
  }
}
